export default __webpack_public_path__ + "static/media/BrainBreak cards52.e26ceb57.png";